import { create } from '@thoughtspot/logger';
import { handleMuzeAiRequest } from './index';
const logger = create('chart-to-ts > muze-ai-host-bridge');
const MSG_FROM_CHART = 'muze-studio-ai';
const MSG_FROM_HOST = 'muze-studio-ai-host';
export function setupMuzeAiHostBridge(opts) {
    const { chartIframeElRef, chartFrameOrigin } = opts;
    const postToChart = (message, targetOrigin) => {
        chartIframeElRef.current?.contentWindow?.postMessage(message, targetOrigin || '*');
    };
    const onMessage = (event) => {
        const data = event.data;
        if (!data || data.source !== MSG_FROM_CHART)
            return;
        if (event.source !== chartIframeElRef.current?.contentWindow)
            return;
        if (chartFrameOrigin && event.origin !== chartFrameOrigin) {
            logger.warn('muze-ai: dropping message from unexpected origin', {
                got: event.origin,
                expected: chartFrameOrigin,
            });
            return;
        }
        const replyOrigin = event.origin || chartFrameOrigin || '*';
        if (data.kind === 'hello') {
            postToChart({ source: MSG_FROM_HOST, kind: 'ready' }, replyOrigin);
            return;
        }
        if (data.kind === 'request') {
            const { requestId, apiType, sessionId, body, convKey } = data;
            const onChunk = (chunk) => postToChart({ source: MSG_FROM_HOST, kind: 'chunk', requestId, chunk }, replyOrigin);
            handleMuzeAiRequest({ apiType, sessionId, body, convKey }, { onChunk })
                .then((res) => {
                if (res.isValid) {
                    return postToChart({ source: MSG_FROM_HOST, kind: 'result', requestId, ok: true, data: res.data }, replyOrigin);
                }
                return postToChart({
                    source: MSG_FROM_HOST,
                    kind: 'result',
                    requestId,
                    ok: false,
                    error: res.errors?.[0] ?? 'Unknown error',
                }, replyOrigin);
            })
                .catch((err) => {
                postToChart({
                    source: MSG_FROM_HOST,
                    kind: 'result',
                    requestId,
                    ok: false,
                    error: err instanceof Error ? err.message : String(err),
                }, replyOrigin);
            });
        }
    };
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
}
//# sourceMappingURL=host-bridge.js.map